export default function getPlayStoreUrl() { 
    return "https://play.google.com/store/apps/details?id=com.clerkie.clerkieandroidapp"
}